import { render } from "./tenant-detail.vue?vue&type=template&id=c1fbb166"
import script from "./tenant-detail.vue?vue&type=script&lang=js"
export * from "./tenant-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__